import React from 'react';
import { TextField, TextButton, Box, useField, classes } from 'bonfire-kindling';

const BaseTextField = ({ ...props }) => (
  <TextField
    sx={{
      '& fieldset': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      '& .MuiFormHelperText-root': {
        margin: theme => `${theme.spacing(2)} 0`,
      },
      flex: '1 1 0%',
    }}
    {...props}
  />
);

const InputGroupFormTextField = ({ name, useFieldConfig, ...props }) => {
  const { input, meta } = useField(name, useFieldConfig);

  return (
    <BaseTextField
      error={!!meta.error || (!meta.dirtySinceLastSubmit && !!meta.submitError)}
      helperText={meta.error || (!meta.dirtySinceLastSubmit && meta.submitError)}
      {...input}
      {...props}
    />
  );
};

const InputGroupTextField = ({ ...props }) => <BaseTextField {...props} />;

const InputGroupButton = ({
  size = 'medium',
  variant = 'contained',
  color = 'primary',
  ...props
}) => (
  <TextButton
    size={size}
    variant={variant}
    color={color}
    sx={{
      [`&.${classes.states.MuiDisabled}`]: {
        border: '2px solid transparent',
      },
      borderWidth: '2px',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    }}
    {...props}
  />
);

const InputGroup = ({ sx, ...props }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '25rem', ...sx }} {...props} />
);

InputGroup.TextField = InputGroupTextField;
InputGroup.FormTextField = InputGroupFormTextField;
InputGroup.Button = InputGroupButton;

export default InputGroup;
